export const messages = {
  lockedPlanTitle: {
    id: "plan.locked-plan-title",
    defaultMessage: "Coming soon",
  },
};
